import { computed, type ExtractPropTypes, type PropType } from 'vue';

import { iconPositionList, type IconPositionType } from '../../typings/iconPositionType';
import { BreakpointDepended } from '../breakpointDepended';
import { defaults } from '../defaults';

export const withIconPositionProps = {
  /**
   * Pozycja ikony
   */
  iconPosition: {
    type: String as PropType<IconPositionType>,
    default: defaults.button.iconPosition
  }
};

/**
 * Zwraca klasy pozycji pola checkbox/radio
 *
 * @export
 * @param {string} prefix
 * @param {ExtractPropTypes<typeof withIconPositionProps>} props
 * @return {*}  {Record<string, boolean>}
 */
export const useIconPositionProps = (prefix: string, props: ExtractPropTypes<typeof withIconPositionProps>) => {
  return computed(() => {
    if (typeof props.iconPosition === 'string') {
      return `${prefix}--icon-position-${props.iconPosition}`;
    } else if (BreakpointDepended(props.iconPosition).value) {
      return `${prefix}--icon-position-${BreakpointDepended(props.iconPosition).value}`;
    }

    return `${prefix}--icon-position-${defaults.button.iconPosition}`;
  });
};

/**
 * Konfiguracja dla storybooka
 */
export const storiesIconPositionArgs = {
  args: {
    iconPosition: defaults.button.iconPosition
  },

  argTypes: {
    iconPosition: {
      options: iconPositionList,
      control: { type: 'inline-radio' }
    }
  }
};
